import Image from 'next/image';
import { useHeadingFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';
import { buildImgProps } from 'utils/media';

import type { ComponentsFeaturedIn } from 'queries/graphql';

import styles from './styles.module.scss';

export default function FeaturedIn({ sectionId, title, images, style }: ComponentsFeaturedIn) {
  const { headingColor, backgroundColor, headingFont } = style || {};

  const headingFontOverrides = useHeadingFontOverrides(headingFont);

  return (
    <div id={sectionId} className={`root ${styles.container} featuredIn`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--heading-color', headingColor, 'var(--heading-color-dark)')}
          ${buildCssVar('--background-color', backgroundColor, 'var(--default-background-color)')}
          ${headingFontOverrides ?? ''}
        }
      `}</style>

      {title && <h1 className={styles.heading}>{title}</h1>}
      <div className={styles.featured_in}>
        {images.map(item => {
          return (
            <div className={styles.image_wrapper} key={item.id}>
              <Image {...buildImgProps(item.image)} alt={item.image?.alt} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
